import { SummaryTable } from '../SummaryTable.js';
import { SummaryTableBoldDivider } from '../SummaryTableBoldDivider.tsx';
import { SummaryTableRowFromMetadataStringProperty } from '../SummaryTableRowFromMetadataStringProperty.tsx';
import { SummaryTableRowFromResultProperty } from '../SummaryTableRowFromResultProperty.tsx';
import { SummaryTitleRow } from '../SummaryTitleRow.js';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { wholeDollar } from '../utils/formatters/wholeDollar.ts';

export const AdjustmentBreakdownSiteValueTable = ({
  sequence,
  tableIdx,
  ...props
}: Tkv2PairedCostSummaryInterfaceV2 & {
  sequence: string[];
  tableIdx: number;
}) => {
  return (
    <SummaryTable key={`breakdown-table-${tableIdx}`}>
      <SummaryTitleRow summary={props} sequence={sequence} tableIdx={tableIdx} />
      <SummaryTableRowFromResultProperty
        section={props}
        sequence={sequence}
        isFirstRow={true}
        label="Site Features"
        path="features.site.text"
      />
      <SummaryTableRowFromMetadataStringProperty
        section={props}
        sequence={sequence}
        label="Sale Price"
        path="salePrice"
      />
      <SummaryTableRowFromResultProperty
        section={props}
        sequence={sequence}
        label="+ Market conditions adjustment"
        path="totals.marketAdjustment"
        formatter={adjustment}
        isHiddenForSubject
      />
      <SummaryTableRowFromResultProperty
        section={props}
        sequence={sequence}
        label="- Depreciated cost of improvements"
        path="totals.improvements.depreciated.cost"
        formatter={wholeDollar}
      />
      <SummaryTableBoldDivider />
      <SummaryTableRowFromResultProperty
        section={props}
        sequence={sequence}
        label="= Opinion of site value as of the effective date"
        path="totals.site.marketAdjusted.siteValue.totalCost"
        typeVariant="h5"
        formatter={wholeDollar}
      />
      <SummaryTableRowFromResultProperty
        section={props}
        sequence={sequence}
        label="Site Adjustment"
        path="adjustments.site.adjustment"
        formatter={adjustment}
        isHiddenForSubject
      />
    </SummaryTable>
  );
};
